module.exports = __webpack_public_path__ + "img/huangguan.6dd9dcea.png";